define('datakit/lib/extracted.relationship.type',['require','exports','module','backbone','marionette','./relationship.type'],function(require, exports, module) {
  var Backbone         = require('backbone');
  var Mn               = require('marionette');
  var RelationshipType = require('./relationship.type');


  var ExtractedRelationshipType = RelationshipType.extend({
    initialize: function() {
      RelationshipType.prototype.initialize.apply(this,arguments);
      this.hasForeignModelFetched = false;
      this.listenToOnce(this.foreignModel, 'sync', function() {
        this.hasForeignModelFetched = true;
      });
    },
    clearOnForeignModelEvent: function() {
      return 'corrupt';
    },
    staleOnForeignModelEvent: function() {
      return 'sync';
    },
    // returns promise or xhr
    fetchResource: function(options) {
      return this.foreignModel;
    },
    canFetchResource: function() {
      return this.hasForeignModelFetched;
    },
    parseResponse: function(model) {
      var extractMethod = this.getOption('extract');
      var extractedValue = Mn._getValue(extractMethod, this, [model]);
      if (extractedValue === void(0)) {
        this.relationship.clearResource();
      }
      return extractedValue;
    }
  });

  module.exports = ExtractedRelationshipType;
});
